import {
  Component,
  OnInit,
  Input,
  PACKAGE_ROOT_URL,
  TemplateRef,
  ChangeDetectionStrategy,
} from "@angular/core";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";
import { OpenAppModalComponent } from "./modals/open-app-modal.component";
import { EditAppsModalComponent } from "./modals/edit-apps-modal.component";
import { Subscription } from "rxjs";
import { EditAppsModalService } from "./modals/edit-apps-modal.service";
import * as _ from "underscore";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { NgIf } from "@angular/common";

@Component({
    selector: "app-apps-item",
    templateUrl: "./apps-item.component.html",
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, TooltipModule]
})
export class AppsItemComponent implements OnInit {
  @Input() app: any;
  @Input() type: any;
  @Input() allowVault = true;

  public modalRef: BsModalRef;

  constructor(
    private modalService: BsModalService,
    private editAppsModalService: EditAppsModalService
  ) {}

  ngOnInit(): void {}

  openEditAppModal(event, app): void {
    event.stopPropagation();
    this.modalRef = this.modalService.show(EditAppsModalComponent, {
      class: "modal-lg",
    });
    this.modalRef.content.ngOnChanges({ app: app });

    this.modalService.onHide.subscribe((reason: string) => {
      if (
        this.editAppsModalService.app !== null &&
        this.editAppsModalService.app !== undefined
      ) {
        if (this.app.id === this.editAppsModalService.app.id) {
          this.app = this.editAppsModalService.app;
        }

        this.editAppsModalService.app = null;
      }
    });
  }

  openOpenAppModal(app): void {
    console.log(app);
    if (app.vault !== null) {
      if (app.vault.username === "" || app.vault.password === "") {
        window.open(app.url, "_blank");
      } else {
        this.modalRef = this.modalService.show(OpenAppModalComponent, {
          class: "modal-lg",
        });
        this.modalRef.content.ngOnChanges({ app: app });
      }
    } else {
      window.open(app.url, "_blank");
    }
  }
}
